import { sanitizeInputs } from './utils/sanitizeInputs'
import type { DashboardCardFilters } from '../types'
import {
    updateAlphaNumericField,
    updateHasWords,
    updateLowHighOperatorField,
    updateNotOperatorField,
    updateNumberOperatorField,
    updateOdomter,
    updateRepField,
    updateYear,
} from './fields'

/** Convert DashboardCardConfig to AQL string */
export const convertDashboardCardFiltersToAQL = (filters: DashboardCardFilters, priorAQL = ''): string => {
    const vehicleFilters = sanitizeInputs(filters.vehicle)
    const saleFilters = sanitizeInputs(filters.sale)
    const companyFilters = sanitizeInputs(filters.company)
    const contactFilters = sanitizeInputs(filters.contact)
    const { hasWords } = sanitizeInputs({ hasWords: filters.hasWords })

    let updateSearch = priorAQL

    updateSearch = updateHasWords(updateSearch, hasWords)

    // VEHICLE FILTERS
    updateSearch = updateAlphaNumericField(updateSearch, 'make', vehicleFilters.make)
    updateSearch = updateAlphaNumericField(updateSearch, 'model', vehicleFilters.model)
    updateSearch = updateAlphaNumericField(updateSearch, 'color', vehicleFilters.color)
    updateSearch = updateNumberOperatorField(updateSearch, 'checkIn', vehicleFilters.checkIn)
    updateSearch = updateYear(updateSearch, vehicleFilters.year, vehicleFilters.yearLow, vehicleFilters.yearHigh)
    updateSearch = updateOdomter(updateSearch, vehicleFilters.odo, vehicleFilters.odoLow, vehicleFilters.odoHigh)
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'photos',
        vehicleFilters.photos,
        vehicleFilters.photosLow,
        vehicleFilters.photosHigh,
    )
    updateSearch = updateAlphaNumericField(updateSearch, 'hasCr', vehicleFilters.hasCr)
    updateSearch = updateAlphaNumericField(updateSearch, 'hasTitle', vehicleFilters.hasTitle)

    // SALE FILTERS
    updateSearch = updateAlphaNumericField(updateSearch, 'saleStatus', saleFilters.saleStatus)
    updateSearch = updateNumberOperatorField(updateSearch, 'saleDate', saleFilters.saleDate)
    updateSearch = updateAlphaNumericField(updateSearch, 'lane', saleFilters.lane)
    updateSearch = updateAlphaNumericField(updateSearch, 'run', saleFilters.run)
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'ranCount',
        saleFilters.ranCount,
        saleFilters.ranCountLow,
        saleFilters.ranCountHigh,
    )
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'lot',
        saleFilters.lot,
        saleFilters.lotLow,
        saleFilters.lotHigh,
    )
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'floor',
        saleFilters.floor,
        saleFilters.floorLow,
        saleFilters.floorHigh,
    )
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'mmr',
        saleFilters.mmr,
        saleFilters.mmrLow,
        saleFilters.mmrHigh,
    )
    updateSearch = updateLowHighOperatorField(
        updateSearch,
        'blackbook',
        saleFilters.blackbook,
        saleFilters.blackbookLow,
        saleFilters.blackbookHigh,
    )

    // COMPANY FILTERS
    updateSearch = updateAlphaNumericField(updateSearch, 'seller', companyFilters.seller)
    updateSearch = updateNotOperatorField(updateSearch, 'sellerId', companyFilters.sellerIdOp, companyFilters.sellerId)
    updateSearch = updateNotOperatorField(
        updateSearch,
        'sellerType',
        companyFilters.sellerTypeOp,
        companyFilters.sellerType,
    )
    updateSearch = updateAlphaNumericField(updateSearch, 'buyer', companyFilters.buyer)
    updateSearch = updateNotOperatorField(updateSearch, 'buyerId', companyFilters.buyerIdOp, companyFilters.buyerId)
    updateSearch = updateNotOperatorField(
        updateSearch,
        'buyerType',
        companyFilters.buyerTypeOp,
        companyFilters.buyerType,
    )
    updateSearch = updateRepField(updateSearch, companyFilters.repType, companyFilters.repOp, companyFilters.rep)
    updateSearch = updateAlphaNumericField(updateSearch, 'isFavorite', companyFilters.isFavorite)

    // CONTACT FILTERS
    updateSearch = updateAlphaNumericField(updateSearch, 'contactStatus', contactFilters.contactStatus)
    updateSearch = updateAlphaNumericField(updateSearch, 'contactMethod', contactFilters.contactMethod)
    updateSearch = updateAlphaNumericField(updateSearch, 'creatorFullName', contactFilters.creatorFullName)
    updateSearch = updateAlphaNumericField(updateSearch, 'followupFullName', contactFilters.followupFullName)
    updateSearch = updateAlphaNumericField(updateSearch, 'completedFullName', contactFilters.completedFullName)
    updateSearch = updateNumberOperatorField(updateSearch, 'contactedAt', contactFilters.contactedAt)
    updateSearch = updateNumberOperatorField(updateSearch, 'followupAt', contactFilters.followupAt)
    updateSearch = updateNumberOperatorField(updateSearch, 'completedAt', contactFilters.completedAt)

    return updateSearch.replace(/\s\s/g, ' ').trim()
}

export default convertDashboardCardFiltersToAQL
